/**
 * Opens a URL in Microsoft Edge browser
 * @param {string} url - The URL to open
 * @param {boolean} forceEdge - Whether to force open in Edge (default: true)
 * @deprecated Use openExternalLink instead for standard behavior
 */
const openInEdge = (url, forceEdge = true) => {
  try {
    if (forceEdge && window.navigator.userAgent.includes('Windows')) {
      // For Windows - using microsoft-edge: protocol
      window.open(`microsoft-edge:${url}`);
    } else if (forceEdge && window.navigator.userAgent.includes('Mac')) {
      // For macOS - using the open command
      const exec = window.require?.('child_process')?.exec;
      if (exec) {
        exec(`open -a "Microsoft Edge" "${url}"`);
      } else {
        // Fallback for web environment or if exec is not available
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    } else {
      // Fallback for other platforms or if forceEdge is false
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    console.error('Error opening in Edge:', error);
    // Fallback to standard window.open if anything fails
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

/**
 * Wrapper for opening external links that should open in Edge
 */
export const openExternalLink = (url) => {
  openInEdge(url, true);
};
